import { Injectable } from '@angular/core';
import { Competition } from '../models/competition.model';
import { CompetitionStatus } from '../models/competition-type.enum';
import {
  CompetitionDealersFormData,
  CompetitionDetailsFormData,
  CompetitionProductsFormData,
  EditCompetitionFormData,
  UpdateCompetition,
} from '../models/create-competition.model';

@Injectable({ providedIn: 'root' })
export class CompetitionHelperService {
  static mapToUpdateCompetition(competition: Competition): UpdateCompetition {
    return {
      ...competition,
      startDate: new Date(competition.startDate),
      endDate: new Date(competition.endDate),
      dealers: competition.dealers.map(dealer => ({ id: dealer.id, name: dealer.name })),
    } as UpdateCompetition;
  }

  static isActiveCompetition(competition: Competition): boolean {
    return competition.status === CompetitionStatus.Active;
  }

  static isUpcomingCompetition(competition: Competition): boolean {
    return competition.status === CompetitionStatus.Upcoming;
  }

  static isEndedCompetition(competition: Competition): boolean {
    return competition.status === CompetitionStatus.Ended;
  }

  static getTotalSales(competition: Competition): number {
    return (competition.competitionSellers ?? []).reduce((sum, seller) => sum + seller.totalSales, 0);
  }

  //TODO; remove when all old competitions have been deleted and sellerCount is populated
  static getCompetitionSellers(competition: Competition): number {
    if (competition.sellerCount) return competition.sellerCount;

    return competition.dealers.reduce((acc, dealer) => acc + dealer.sellers.length, 0);
  }

  static mapToCompetitionDetailsFormModel(competition: Competition): CompetitionDetailsFormData {
    return {
      details: {
        name: competition.name,
        description: competition.description,
        type: competition.type,
        saleType: competition.saleType,
        startDate: competition.startDate,
        endDate: competition.endDate,
        salesGoal: competition.salesGoal,
      },
    } as CompetitionDetailsFormData;
  }

  static mapToCompetitionProductsFormModel(competition: Competition): CompetitionProductsFormData {
    return {
      products: {
        saleType: competition.saleType,
        type: competition.type,
      },
    } as CompetitionProductsFormData;
  }

  static mapToCompetitionDealersFormModel(competition: Competition): CompetitionDealersFormData {
    return {
      isHidden: competition.isHidden,
      dealers: competition.dealers.map(dealer => ({ id: dealer.id, name: dealer.name })),
    } as CompetitionDealersFormData;
  }

  static mapToEditCompetitionFormModel(competition: Competition): EditCompetitionFormData {
    return {
      details: {
        name: `${competition.name} (Kopi)`,
        description: competition.description,
        type: competition.type,
        saleType: competition.saleType,
      },
    } as EditCompetitionFormData;
  }
}
